import React from 'react';
import { useRouter } from 'next/router';
import { i18n, useTranslation } from 'next-i18next';
import { imageUrl } from '~/utils/url-helpers';
import {
    HeaderContainer,
    HeaderInnerContainer,
    HeaderLogoContainer,
    LanguageToggleContainer,
    HeaderRightContainer,
    HeaderButton,
} from './styles';
import setLocale from '~/locale/set-locale';
import Image from 'next/image';
import Link from '~/components/common/link';

const Header = () => {
    const router = useRouter();
    const { t } = useTranslation('base-layout');

    const switchLocale = React.useCallback(() => {
        if (i18n) {
            const lang = i18n?.language === 'en' ? 'fr' : 'en';
            setLocale(lang);
            const { pathname, asPath, query } = router;
            router.push({ pathname, query }, asPath, { locale: lang });
        }
    }, [router]);

    return (
        <HeaderContainer>
            <HeaderInnerContainer>
                <HeaderLogoContainer>
                    <Link href={t('base-layout:header.logoLink', { defaultValue: '#' }) as string}>
                        <Image
                            src={imageUrl('/images/ontario-logo--desktop.svg')}
                            alt={t('base-layout:header.logoAltText')}
                            width="100"
                            height="25"
                        />
                    </Link>
                </HeaderLogoContainer>
                <HeaderRightContainer>
                    <LanguageToggleContainer>
                        <HeaderButton
                            aria-label={t('base-layout:header.langAriaLabel')}
                            type="button"
                            onClick={switchLocale}
                        >
                            {t('base-layout:header.lang')}
                        </HeaderButton>
                    </LanguageToggleContainer>
                </HeaderRightContainer>
            </HeaderInnerContainer>
        </HeaderContainer>
    );
};

export default Header;
